import { setObjectValueByPath } from "../../utils/helpers/objectValueByPath"

export const SetSettingsReducerd = (state, action) => {
    switch (action?.type){
 
        // Встановлюємо всю структуру параметрів
        case 'SET':
            return {...action.settings}

        // Встановлюємо одне значення
        case 'SET_FIELD':
            const newLocalSettings = setObjectValueByPath(state, action.field, action.value);
            return {...newLocalSettings}            
    }
}